import { makeStyles } from '@material-ui/core/styles';

export const infoStyles = makeStyles(theme => ({
    infoContainer: {
        margin: '16px 0 10px',
        display: 'flex',
        alignItems: 'center'
    }
}));
